// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"492":"0c2b503e","496":"a39032cf"}[chunkId] + ".chunk.js";
};